<main class="gestor"
      (dragover)="aoArrastar($event, true)"
      (dragleave)="aoArrastar($event, false)"
      (drop)="aoSoltar($event)">

  <header class="gestor__cabecalho">
    <h1 class="gestor__titulo">
      <i class="fas fa-rocket" aria-hidden="true"></i>
      Implantação assistida
    </h1>
    <p class="gestor__linha-fina">
      <ng-container *ngIf="conversa.onboardingId">implantação #{{ conversa.onboardingId }}</ng-container>
      <ng-container *ngIf="conversa.empresaId"> · empresa #{{ conversa.empresaId }}</ng-container>
      <ng-container *ngIf="!conversa.onboardingId && conversa.carregando">retomando…</ng-container>
    </p>
    <a class="gestor__simulador" routerLink="/admin/mia-gestor/comercial">Atendimento comercial</a>
    <a class="gestor__simulador" routerLink="/admin/mia-gestor/simulador">
      <i class="fab fa-whatsapp" aria-hidden="true"></i> Simulador
    </a>
  </header>

  <!-- faixa de progresso: informa, não navega -->
  <ol class="progresso" aria-label="Progresso da implantação">
    <li *ngFor="let passo of passos" class="progresso__passo" [ngClass]="'progresso__passo--' + passo.estado">
      <span class="progresso__marca" aria-hidden="true"></span>
      <span class="progresso__texto">
        <strong>{{ passo.rotulo }}</strong>
        <small>{{ passo.detalhe }}</small>
      </span>
    </li>
  </ol>

  <div class="gestor__aviso gestor__aviso--erro" *ngIf="conversa.erro">
    <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
    <span>{{ conversa.erro }}</span>
  </div>

  <div class="gestor__aviso gestor__aviso--erro" *ngIf="conversa.dnsTemErro">
    <i class="fas fa-globe" aria-hidden="true"></i>
    <span>Um dos endereços da loja não subiu.</span>
    <button type="button" (click)="abraFicha()">Ver quais</button>
  </div>

  <div class="gestor__aviso" *ngIf="!conversa.verificandoAgente && !conversa.agenteDisponivel">
    <i class="fas fa-plug" aria-hidden="true"></i>
    <span>
      <strong>A Mia está fora do ar.</strong>
      Você ainda pode enviar o cardápio, revisar o rascunho e aprovar o que já foi proposto —
      isso fala com o Servidor, não com o serviço de IA.
    </span>
    <button type="button" (click)="tentarDeNovo()">Tentar de novo</button>
  </div>

  <!-- ===================== janela do chat ===================== -->
  <section class="janela">
    <div class="janela__solte" *ngIf="arrastando">
      <i class="fas fa-file-import" aria-hidden="true"></i>
      <span>Solte aqui o cardápio</span>
    </div>

    <header class="janela__topo">
      <button type="button" class="janela__contato" (click)="abraFicha()"
              title="Dados da implantação">
        <span class="janela__avatar" aria-hidden="true"><i class="fas fa-headset"></i></span>
        <span class="janela__quem">
          <strong>MIA Gestor</strong>
          <small>
            <ng-container *ngIf="conversa.carregando">retomando o último estado salvo…</ng-container>
            <ng-container *ngIf="!conversa.carregando">{{ conversa.etapaLegivel }}</ng-container>
          </small>
        </span>
      </button>
      <span class="janela__estado"
            [class.janela__estado--fora]="!conversa.verificandoAgente && !conversa.agenteDisponivel">
        {{ conversa.verificandoAgente ? 'verificando' : conversa.agenteDisponivel ? 'online' : 'fora do ar' }}
      </span>

      <button type="button" class="janela__reiniciar" *ngIf="!confirmandoReinicio"
              [disabled]="!conversa.onboardingId || conversa.reiniciando"
              title="Encerra esta implantação e abre outra do zero"
              (click)="confirmandoReinicio = true">
        <i class="fas fa-redo-alt" aria-hidden="true"></i> Começar do zero
      </button>

      <span class="janela__confirma" *ngIf="confirmandoReinicio">
        <small>Encerra esta implantação. Empresa e produtos já criados continuam existindo.</small>
        <button type="button" (click)="confirmandoReinicio = false">Voltar</button>
        <button type="button" class="janela__confirma--sim" [disabled]="conversa.reiniciando"
                (click)="reinicie()">
          {{ conversa.reiniciando ? 'Começando…' : 'Começar do zero' }}
        </button>
      </span>
    </header>

    <div #listaMensagens class="conversa" aria-live="polite">

      <div class="conversa__esqueleto" *ngIf="conversa.carregando">
        <span></span><span></span><span></span>
      </div>

      <p class="conversa__vazia" *ngIf="!conversa.mensagens.length && !conversa.carregando">
        A conversa começa com você — mande um oi que a Mia se apresenta e cuida do resto.
      </p>

      <!-- linhaDoTempo = histórico + a bolha que ainda espera ação (ver a store) -->
      <ng-container *ngFor="let item of conversa.linhaDoTempo">
        <p class="nota" *ngIf="item.papel === 'nota'">{{ item.texto }}</p>

        <div class="fala" *ngIf="item.papel !== 'nota'"
             [class.fala--minha]="item.papel === 'usuario'">
          <div class="balao">
            <!-- anexo do cardápio: cartão de documento, como no WhatsApp -->
            <div class="balao__documento" *ngIf="item.documento">
              <i class="fas" [class.fa-file-pdf]="item.documento.quantidade === 1"
                 [class.fa-images]="item.documento.quantidade > 1" aria-hidden="true"></i>
              <span>
                <b>{{ item.texto }}</b>
                <small>{{ conversa.tamanhoLegivel(item.documento.tamanhoBytes) }}</small>
              </span>
            </div>

            <p class="balao__texto" *ngIf="!item.documento">
              <ng-container *ngFor="let trecho of partesDaMensagem(item.texto)">
                <a class="balao__link" *ngIf="trecho.link" [href]="trecho.link"
                   target="_blank" rel="noopener noreferrer">{{ trecho.texto }}</a>
                <strong *ngIf="trecho.destaque && !trecho.link">{{ trecho.texto }}</strong>
                <ng-container *ngIf="!trecho.destaque && !trecho.link">{{ trecho.texto }}</ng-container>
              </ng-container>
            </p>

            <span class="balao__ferramentas" *ngIf="item.ferramentas?.length">
              <span class="chip" *ngFor="let ferramenta of item.ferramentas"
                    [class.chip--erro]="!ferramenta.sucesso"
                    [title]="ferramenta.nome + ' · ' + ferramenta.duracaoMs + 'ms'">
                {{ conversa.rotuloDaFerramenta(ferramenta.nome) }}
              </span>
            </span>

            <span class="balao__hora">{{ item.horario | date:'HH:mm' }}</span>

            <!-- o interativo do canal: botões de resposta, cta_url ou lista -->
            <ng-container *ngIf="item.interativo as interativo">
              <button type="button" class="balao__botao"
                      *ngFor="let botao of interativo.botoes"
                      [class.balao__botao--link]="botao.acao === 'abrir'"
                      [disabled]="!botaoAtivo(botao)"
                      (click)="aoTocarBotao(botao)">
                <i class="fas fa-external-link-alt" *ngIf="botao.acao === 'abrir'"
                   aria-hidden="true"></i>
                {{ botao.rotulo }}
              </button>

              <button type="button" class="balao__botao"
                      *ngIf="interativo.tipo === 'lista'"
                      (click)="abraFolha(interativo)">
                <i class="fas fa-list-ul" aria-hidden="true"></i>
                {{ interativo.rotulo }}
              </button>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <!-- a análise é longa: a Mia avisa que está lendo, com a contagem real -->
      <div class="fala" *ngIf="conversa.analisando">
        <div class="balao">
          <p class="balao__texto">Lendo seu cardápio… 🔎<ng-container *ngIf="conversa.progressoAnalise"> Já achei <strong>{{ conversa.progressoAnalise.produtos }} produto(s)</strong> em <strong>{{ conversa.progressoAnalise.categorias }} categoria(s)</strong>.</ng-container></p>
          <span class="balao__hora">agora</span>
        </div>
      </div>

      <div class="fala" *ngIf="conversa.enviando">
        <div class="balao balao--digitando"><span></span><span></span><span></span></div>
      </div>
    </div>

    <!-- ===================== caixa de mensagem ===================== -->
    <div class="escrita">
      <input #seletorRodape type="file" hidden multiple
             accept="application/pdf,image/jpeg,image/png,image/webp"
             (change)="selecioneArquivos($event)">
      <button type="button" class="escrita__anexo" [disabled]="!conversa.podeEnviarCardapio"
              [class.escrita__anexo--pedindo]="conversa.podeEnviarCardapio"
              [title]="conversa.podeEnviarCardapio ? 'Anexar o cardápio' : 'O anexo abre quando a empresa existir'"
              (click)="seletorRodape.click()">
        <i class="fas fa-plus" aria-hidden="true"></i>
      </button>
      <textarea #campoMensagem
                name="mensagemGestor"
                rows="1"
                maxlength="4000"
                [(ngModel)]="mensagem"
                (keydown)="aoPressionarTecla($event)"
                placeholder="Escreva para a Mia…"
                [disabled]="conversa.enviando || conversa.carregando || !conversa.onboardingId"></textarea>
      <button type="button" class="escrita__enviar" (click)="envie()"
              [disabled]="!mensagem.trim() || conversa.enviando || conversa.carregando || !conversa.onboardingId">
        <i class="fas fa-paper-plane" aria-hidden="true"></i>
      </button>
    </div>
  </section>
  <p class="escrita__dica"><kbd>Enter</kbd> envia · <kbd>Shift + Enter</kbd> quebra a linha</p>

  <!-- ===================== gaveta do rascunho ===================== -->
  <div class="gaveta" *ngIf="gavetaAberta">
    <div class="gaveta__fundo" (click)="fecheGaveta()"></div>

    <aside class="gaveta__painel" *ngIf="conversa.analiseCardapio as analise">
      <header class="gaveta__topo">
        <span>
          <strong>Revisar cardápio</strong>
          <small>rascunho v{{ analise.versao }}</small>
        </span>
        <button type="button" (click)="fecheGaveta()" title="Fechar">
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </header>

      <div class="gaveta__filtros">
        <button type="button" [class.ativo]="filtroRascunho === 'todos'"
                (click)="mudeFiltro('todos')">todos {{ contagens.todos }}</button>
        <button type="button" [class.ativo]="filtroRascunho === 'pendencia'"
                (click)="mudeFiltro('pendencia')">com pendência {{ contagens.pendencia }}</button>
        <button type="button" [class.ativo]="filtroRascunho === 'sem-preco'"
                (click)="mudeFiltro('sem-preco')">sem preço {{ contagens['sem-preco'] }}</button>
        <button type="button" [class.ativo]="filtroRascunho === 'importados'"
                (click)="mudeFiltro('importados')">já importados {{ contagens.importados }}</button>
        <span class="gaveta__marcar">
          <button type="button" (click)="conversa.marqueTodosOsProdutos(true)">marcar todos</button>
          <button type="button" (click)="conversa.marqueTodosOsProdutos(false)">nenhum</button>
        </span>
      </div>

      <div class="gaveta__lista">
        <section class="grupo" *ngFor="let grupo of grupos">
          <h3 class="grupo__titulo">
            <input [(ngModel)]="grupo.categoria.nome" name="cat-{{ grupo.categoria.referencia }}"
                   maxlength="160" [disabled]="grupo.travada">
            <small>{{ grupo.produtos.length }} itens</small>
          </h3>

          <article class="item" *ngFor="let produto of grupo.produtos"
                   [class.item--bloqueado]="conversa.produtoTemBloqueio(produto)"
                   [class.item--travado]="jaImportado(produto.referencia)">
            <label class="item__marca">
              <input type="checkbox" [(ngModel)]="produto.selecionado"
                     name="sel-{{ produto.referencia }}"
                     [disabled]="jaImportado(produto.referencia)">
            </label>

            <div class="item__corpo">
              <input class="item__nome" [(ngModel)]="produto.nome" name="nome-{{ produto.referencia }}"
                     maxlength="160" [disabled]="jaImportado(produto.referencia)">

              <div class="item__linha">
                <label class="item__preco" *ngIf="!ehPizza(produto)">
                  R$
                  <input type="number" min="0" step="0.01" [(ngModel)]="produto.preco"
                         name="preco-{{ produto.referencia }}"
                         [disabled]="jaImportado(produto.referencia)">
                </label>
                <span class="item__preco item__preco--tamanhos" *ngIf="ehPizza(produto)"
                      title="O preço da pizza é por tamanho: edite no grupo Tamanho, nos adicionais.">
                  {{ precoDaPizza(produto) }}
                </span>
                <span class="item__selo" *ngIf="jaImportado(produto.referencia)">já importado</span>
                <button type="button" class="item__abrir" *ngIf="produto.adicionais?.length"
                        (click)="alterneProduto(produto.referencia)">
                  {{ produto.adicionais.length }} grupo(s) de adicionais
                  <i class="fas" [class.fa-chevron-down]="produtoAberto !== produto.referencia"
                     [class.fa-chevron-up]="produtoAberto === produto.referencia" aria-hidden="true"></i>
                </button>
              </div>

              <p class="item__motivo" *ngIf="motivoDoBloqueio(produto)">
                <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                {{ motivoDoBloqueio(produto) }}
              </p>

              <div class="item__detalhe" *ngIf="produtoAberto === produto.referencia">
                <label class="item__descricao">
                  Descrição
                  <textarea rows="2" maxlength="2000" [(ngModel)]="produto.descricao"
                            name="desc-{{ produto.referencia }}"
                            [disabled]="jaImportado(produto.referencia)"></textarea>
                </label>

                <div class="adicional" *ngFor="let adicional of produto.adicionais">
                  <div class="adicional__topo">
                    <input [(ngModel)]="adicional.nome" name="ad-{{ adicional.referencia }}" maxlength="160"
                           [disabled]="jaImportado(produto.referencia)">
                    <small>
                      {{ adicional.tipoSelecao || 'tipo pendente' }} ·
                      mín. {{ adicional.minimo }} · máx. {{ adicional.maximo }}
                    </small>
                  </div>
                  <div class="opcao" *ngFor="let opcao of adicional.opcoes">
                    <input [(ngModel)]="opcao.nome" name="op-{{ opcao.referencia }}" maxlength="160"
                           [disabled]="jaImportado(produto.referencia)">
                    <input type="number" min="0" step="0.01" [(ngModel)]="opcao.preco"
                           name="op-preco-{{ opcao.referencia }}"
                           [disabled]="jaImportado(produto.referencia)">
                  </div>
                </div>
              </div>
            </div>
          </article>
        </section>

        <p class="gaveta__vazio" *ngIf="!grupos.length">
          Nenhum item nesse filtro.
        </p>
      </div>

      <footer class="gaveta__rodape">
        <span>
          <strong>{{ conversa.referenciasSelecionadas.length }} de {{ conversa.totalProdutosRascunho }}</strong>
          selecionados
          <em *ngIf="conversa.bloqueiosRascunho">· {{ conversa.bloqueiosRascunho }} bloqueios</em>
        </span>
        <span class="gaveta__botoes">
          <button type="button" class="botao-forte botao-forte--secundaria"
                  [disabled]="conversa.operandoCardapio" (click)="salveRascunho()">Salvar</button>
          <button type="button" class="botao-forte"
                  [disabled]="conversa.operandoCardapio || !conversa.referenciasSelecionadas.length"
                  (click)="prepareImportacao()">
            {{ conversa.operandoCardapio ? 'Preparando…' : 'Preparar importação' }}
          </button>
        </span>
      </footer>
      <p class="gaveta__aviso">
        Salvar só versiona o rascunho. A importação é aprovada na conversa, não aqui.
      </p>
    </aside>
  </div>

  <!-- ===================== ficha da implantação ===================== -->
  <!-- o que não é mensagem em canal nenhum: id, DNS, contadores. O WhatsApp
       tem essa tela — é tocar no nome do contato. -->
  <div class="gaveta gaveta--ficha" *ngIf="fichaAberta">
    <div class="gaveta__fundo" (click)="fecheFicha()"></div>

    <aside class="gaveta__painel">
      <header class="gaveta__topo">
        <span>
          <strong>Dados da implantação</strong>
          <small>o que a conversa não carrega</small>
        </span>
        <button type="button" (click)="fecheFicha()" title="Fechar">
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </header>

      <div class="gaveta__lista">
        <section class="ficha__bloco">
          <h3>Implantação</h3>
          <dl class="ficha__dados">
            <div><dt>Número</dt><dd>#{{ conversa.onboardingId || '—' }}</dd></div>
            <div><dt>Etapa</dt><dd>{{ conversa.etapaLegivel }}</dd></div>
            <div><dt>Situação</dt><dd>{{ conversa.status }}</dd></div>
            <div><dt>Versão</dt><dd>{{ conversa.versao }}</dd></div>
          </dl>
        </section>

        <section class="ficha__bloco" *ngIf="conversa.provisionamentoEmpresa as provisionamento">
          <h3>Empresa</h3>
          <dl class="ficha__dados">
            <div><dt>Nome</dt><dd>{{ provisionamento.empresa.nome }}</dd></div>
            <div><dt>Empresa</dt><dd>#{{ provisionamento.empresa.id }}</dd></div>
            <div><dt>Catálogo</dt><dd>#{{ provisionamento.catalogo.id }}</dd></div>
            <div><dt>Endereço</dt><dd>{{ provisionamento.empresa.subdominio }}</dd></div>
            <div><dt>Responsável</dt><dd>{{ provisionamento.responsavel.nome }}</dd></div>
          </dl>

          <ul class="ficha__zonas">
            <li *ngFor="let zona of provisionamento.dns"
                [class.ficha__zonas--erro]="zona.status === 'ERRO'">
              <b>{{ zona.hostname }}</b>
              <small>{{ conversa.statusDnsLegivel(zona.status) }}<ng-container *ngIf="zona.erro"> — {{ zona.erro }}</ng-container></small>
            </li>
          </ul>
        </section>

        <section class="ficha__bloco" *ngIf="conversa.analiseCardapio as analise">
          <h3>Cardápio</h3>
          <dl class="ficha__dados">
            <div><dt>Rascunho</dt><dd>v{{ analise.versao }}</dd></div>
            <div><dt>Situação</dt><dd>{{ analise.status }}</dd></div>
            <div><dt>Itens</dt><dd>{{ conversa.totalProdutosRascunho }}</dd></div>
            <div><dt>Categorias</dt><dd>{{ analise.estatisticas?.categorias || 0 }}</dd></div>
            <div><dt>Pendências</dt><dd>{{ conversa.bloqueiosRascunho }}</dd></div>
          </dl>

          <dl class="ficha__dados" *ngIf="analise.resultado as resultado">
            <div><dt>Criados</dt><dd>{{ resultado.importados?.length || 0 }}</dd></div>
            <div><dt>Já existiam</dt><dd>{{ resultado.reutilizados?.length || 0 }}</dd></div>
            <div><dt>Falharam</dt><dd>{{ resultado.falhas?.length || 0 }}</dd></div>
          </dl>
        </section>

        <section class="ficha__bloco" *ngIf="conversa.acaoPendente as acao">
          <h3>Proposta em aberto</h3>
          <dl class="ficha__dados">
            <div><dt>Ação</dt><dd>{{ conversa.tituloDaAcao }}</dd></div>
            <div><dt>Preview</dt><dd>{{ acao.hashPreview | slice:0:12 }}…</dd></div>
            <div><dt>Expira</dt><dd>{{ acao.expiraEm | date:'dd/MM HH:mm' }}</dd></div>
          </dl>
          <p class="ficha__nota">
            Resumo congelado. Se a conversa mudar algo, a proposta cai e a Mia prepara outra.
          </p>
        </section>
      </div>
    </aside>
  </div>

  <!-- ===================== folha da lista ===================== -->
  <!-- list message: no celular o WhatsApp abre uma folha; aqui também -->
  <div class="folha" *ngIf="folha as lista">
    <div class="folha__fundo" (click)="fecheFolha()"></div>

    <div class="folha__painel">
      <header>
        <strong>{{ lista.rotulo }}</strong>
        <button type="button" (click)="fecheFolha()" title="Fechar">
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </header>

      <ul class="folha__itens">
        <li *ngFor="let item of lista.itens">
          <b>{{ item.titulo }}</b>
          <small>{{ item.descricao }}</small>
        </li>
      </ul>
    </div>
  </div>
</main>
